
<template>
   <!-- client area start -->
    <div class="client-area pd-top-92 pd-bottom-100">
        <div class="container">
            <div class="section-title text-center">
                <h2 class="title">Our Partner</h2>
            </div>
            <div class="client-slider">
                <div class="item">
                    <div class="thumb">
                        <img src="/img/pat1.png" alt="client">
                    </div>
                </div>
                <div class="item">
                    <div class="thumb">
                        <img src="/img/pat2.png" alt="client">
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="thumb">
                        <img src="assets/img/client/3.png" alt="client">
                    </div>
                </div> -->
                <!-- <div class="item">
                    <div class="thumb">
                        <img src="assets/img/client/4.png" alt="client">
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    <!-- client area end -->
</template>

<script>
export default {
  name: "Partner",
  
};
</script>


<style>

</style>




 